//# REMOVING THE .sold-out CLASS FROM THE ADD TO CART BUTTON WHEN VARIANT IS AVAILABLE
document.addEventListener("DOMContentLoaded", (event) => {
  const productForm = document.querySelector('.product-form');
  if(!productForm) return;
  
  const addToCartButtons = productForm.querySelectorAll('.single-add-to-cart-button');
  document.addEventListener("product:variant-change", function (evt) {
    let currentVariant = evt.detail.variant;
    if(currentVariant.available) {
      addToCartButtons.forEach(addToCartButton => {
        addToCartButton.classList.remove('sold-out');
      });
    }
  });
});




document.addEventListener("DOMContentLoaded", (event) => {
  let items = [],
      index,
      container = document.querySelector('section.product-section');
  // Create a new click event
  const galleryImageModal = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });

  if(!document.getElementById('Product-Slider')) return;
  
  const Flickity = window.Flickity;  
  const productGallery = document.getElementById('Product-Slider');
  const productGalleryFlickity = new Flickity(productGallery);

  //PRODUCT GALLERY CAROUSEL CLICK EVENT TO ZOOM
  productGalleryFlickity.on('staticClick', function(event,cellElement,cellIndex) {
    const zoomElement = event.target.closest('.product-single__media').querySelector('.product-single__media-zoom');
    zoomElement.dispatchEvent(galleryImageModal);
    event.preventDefault();
  });

  //let pswpContainer = container.querySelectorAll('.pswp')[0];
  const pswpJustClosed = observeInnerHTMLChanges(container.querySelectorAll('.pswp')[0], () => {
    let pswpContainer = container.querySelectorAll('.pswp')[0];
    let itemCounter,
        itemCounterHTML,
        itemArray,
        currentIndex;

    // if(pswpContainer.classList.contains('pswp--visible') && pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML != "") {
    itemCounterHTML = pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML;
    itemArray = itemCounterHTML.split('/');
    currentIndex = parseInt(itemArray[0].trim()) - 1;
    productGalleryFlickity.select(parseInt(currentIndex), false, false);
  });

  function observeInnerHTMLChanges(element, callback) {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          callback();
          break;
        }
      }
    });

    observer.observe(element, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return observer;
  }

  //flkty.append(productGallery.querySelector('.no-variant--image'));
  verticalCenterSliderThumbnail();

  addIdToRecentlyViewed(document.querySelector('[data-handle]').dataset.handle);
});

function verticalCenterSliderThumbnail() {
  let thumbnailsContainer = document.getElementById('Product-Thumbnails');
  let thumbnails = thumbnailsContainer.querySelectorAll('.is-initial-selected');
  let active_thumb = thumbnails[0];

  requestAnimationFrame(() => {
    //console.log(active_thumb.offsetParent);
    if (active_thumb.offsetParent === null) return;
        
    const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
    windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
    active_thumb.parentElement.scrollTo({
      left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
      top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
      behavior: 'smooth'
    });
  });
}

//UPDATE POSITION PROPERTY IN PRODUCT FORM
document.addEventListener("cart:item-added", function (evt) {
  let positionInput = document.querySelector('.product-form [name="properties[_position]"]');
  positionInput.value = parseInt(positionInput.value) - 1;
});

document.addEventListener("line-item:change:end", function (evt) {
  let positionInput = document.querySelector('.product-form [name="properties[_position]"]');
  if(evt.detail.cart.items_removed.length > 0) {
    positionInput.value = parseInt(positionInput.value) + 1;
  } else if(evt.detail.cart.items_added.length > 0) {
    positionInput.value = parseInt(positionInput.value) - 1;
  }
});





/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}



  /********************************/
 /**** VARIANT FORCE REDIRECT ****/
/********************************/
let hasVariantRedirect = false;
let variantRedirectData; 
if(document.getElementById('VariantForceRedirect'))  {
  variantRedirectData = JSON.parse(document.getElementById('VariantForceRedirect').textContent);
  hasVariantRedirect = true;
}

document.addEventListener("DOMContentLoaded", (event) => {  
  if(!document.body.classList.contains('template-product')) return;
  if(!hasVariantRedirect) return;
  
  let datasetVariantId, selectedVariant, redirectToUrl;
  if(variantRedirectData['product_has_only_default_variant'] == true) {    
    redirectToUrl = (variantRedirectData.variants[0]['force_redirect_url']).toString();
  } else {
    datasetVariantId = document.querySelector('.variant-selects').dataset.currentVariant;
    selectedVariant = variantRedirectData.variants.find(variant => variant.variant_id == datasetVariantId);
    console.log("selected", selectedVariant);
    redirectToUrl = selectedVariant['force_redirect_url'];
  }

  if (redirectToUrl == "") return;
  console.log("URL1", redirectToUrl);
  window.location.href = redirectToUrl;  
});

document.addEventListener("product:variant-change", function (evt) {
  if(!hasVariantRedirect) return;
  const selectedVariant = variantRedirectData.variants.find(variant => variant.variant_id == evt.detail.variant.id); 
  //if(!selectedVariant['force_redirect_url'] || selectedVariant['force_redirect_url'] == '' || selectedVariant['force_redirect_url'] == 'undefined') return;
  console.log("selected", selectedVariant);
  if(!selectedVariant || selectedVariant['force_redirect_url'] == "") return;
  window.location.href = selectedVariant['force_redirect_url'];
});


  /********************************/
 /**** PRODUCT FORCE REDIRECT ****/
/********************************/
document.addEventListener("DOMContentLoaded", (event) => {   
  if(document.getElementById('RedirectUrl')) {
    const redirectUrl = document.getElementById('RedirectUrl').value;
    if(redirectUrl) {
      let splitString = redirectUrl.split('/');
      console.log("URL2", splitString[3] + splitString[4]);
      if(splitString) {
        window.location.href = "/"+splitString[3] +"/"+ splitString[4];
      }
    }
  }
});